import { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'

import { Spinner } from '@/components/ui/spinner'
import { getAuthStatus, redeemSignInTicket } from '../../models/auth'
import { createTestAdmin } from '../../models/user'

export function CreateTestAdmin() {
  const [error, setError] = useState<string | null>(null)
  const startedRef = useRef(false)

  useEffect(() => {
    if (startedRef.current) return
    startedRef.current = true

    async function run() {
      let signInToken: string
      try {
        // A fresh browser has no CSRF cookie until this, and redeeming the ticket is a checked write.
        await getAuthStatus()
        signInToken = (await createTestAdmin()).signInToken
      } catch {
        setError('Failed to create test admin.')
        return
      }
      try {
        await redeemSignInTicket(signInToken)
      } catch {
        setError('Failed to log in as the new test admin.')
        return
      }
      window.location.href = '/insure'
    }

    void run()
  }, [])

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-red-600">{error}</p>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Creating test admin</title>
      </Helmet>
      <div className="flex min-h-screen items-center justify-center gap-2">
        <Spinner className="size-6" />
        <span className="text-sm text-gray-500">Creating test admin...</span>
      </div>
    </>
  )
}
